import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

import { useCurrentActor } from 'components/contexts/CurrentActor';

import { pluralizeProjectsName } from 'components/helpers/resources/projects';

export default function ArchiveProjectsModal({
  isArchiveProjectsDisabled = false,
  onArchiveProjectsSubmit,
  onClose,
  projectsCount,
}) {
  const currentActor = useCurrentActor();

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'projectsDashboard.components.ArchiveProjectsModal',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={onClose}
            size='md'
          >
            {i18nTShared('cancel')}
          </TextButton>
          <FilledButton
            color='blue'
            disabled={isArchiveProjectsDisabled}
            onClick={onArchiveProjectsSubmit}
          >
            {i18nTShared('archiveName', {
              interpolation: { escapeValue: false },
              name: pluralizeProjectsName({
                count: projectsCount,
                currentActor,
              }),
            })}
          </FilledButton>
        </div>
      }
      isOpen={true}
      mode='flexible'
      onClose={onClose}
    >
      <div className='tw-p-6'>
        <h2 className='modalbox-header__title truncated-text-container tw-text-xl tw-font-semibold tw-text-grey-900'>
          {i18nT('title', {
            count: projectsCount,
            interpolation: { escapeValue: false },
            pluralRAMSName: pluralizeProjectsName({
              count: projectsCount,
              currentActor,
            }),
          })}
        </h2>
      </div>
    </ModalBox>
  );
}

ArchiveProjectsModal.propTypes = {
  isArchiveProjectsDisabled: PropTypes.bool,
  onArchiveProjectsSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  projectsCount: PropTypes.number.isRequired,
};
